import { SadPage } from "./SadPage"

type Props = {
  kioskMode?: boolean
}

/**
 * Shown when something failed at our end rather than because of anything the
 * client did — a 5xx, a dropped connection, or a reply we could not read.
 *
 * Lives here rather than in a module because two unrelated callers need the same
 * page: ErrorBoundary, which wraps the whole app, and the feedback invitation
 * gate. Extracted so the two cannot drift into saying different things about the
 * same situation.
 */
export function SomethingWentWrongPage({ kioskMode }: Props) {
  return (
    <SadPage
      kioskMode={kioskMode}
      lines={[
        "Something went wrong.",
        "Please refresh the page and try again.",
      ]}
    />
  )
}
